var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 342.57,
    x2: 409.61,
    y1: 309.6,
    y2: 309.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef0f1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 307.37,
    x2: 332.36,
    xlinkHref: "#linear-gradient",
    y1: 81.4,
    y2: 81.4
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 282.38,
    x2: 307.37,
    xlinkHref: "#linear-gradient",
    y1: 81.4,
    y2: 81.4
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    gradientTransform: "matrix(.71 -.71 .71 .71 70.32 317.77)",
    x1: 377.56,
    x2: 402.55,
    xlinkHref: "#linear-gradient",
    y1: 56.2,
    y2: 56.2
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    gradientTransform: "matrix(.71 -.71 .71 .71 70.32 317.77)",
    x1: 352.57,
    x2: 377.56,
    xlinkHref: "#linear-gradient",
    y1: 56.2,
    y2: 56.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty_Cart",
    "data-name": "Empty Cart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m171.19 186.06 28.61 173.93h200.59l13.52-147.86z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.16 240.94a10.59 10.59 0 0 1 9.6 11.62l-7.22 71.57a6.9 6.9 0 0 1 -13.76-.68l-.15-71.93a10.6 10.6 0 0 1 11.53-10.58z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.61 259.21-9.22 100.79h-52.9c-17.49-45.81 13.6-95.81 62.12-100.79z",
    fill: "url(#linear-gradient)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.97,
    cy: 426.15,
    fill: "#5e6175",
    r: 17.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.97,
    cy: 426.15,
    fill: "#f5f5f5",
    r: 6.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.94,
    cy: 426.15,
    fill: "#5e6175",
    r: 17.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.94,
    cy: 426.15,
    fill: "#f5f5f5",
    r: 6.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.94 447.14a21 21 0 1 1 21-21 21 21 0 0 1 -21 21zm0-36a15 15 0 1 0 15 15 15 15 0 0 0 -15-14.97z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314 447.14a21 21 0 1 1 21-21 21 21 0 0 1 -21 21zm0-36a15 15 0 1 0 15 15 15 15 0 0 0 -15-14.97z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.34 121.92h18.01v6h-18.01z",
    fill: "#5e6175",
    transform: "matrix(.707 -.707 .707 .707 -43.13 145.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.13 103.85h6v18.01h-6z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.9 142.04h18.01v6h-18.01z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.19 186.06h-78.23l46.94 173.93h59.9z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5e6175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m403.13 363h-205.88l-29.66-180.34 249.58 26.8zm-200.78-6h195.3l13-142.2-235.86-25.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.33 363h-65.73l-48.6-179.94h84.7zm-61.13-6h54.07l-27.63-167.94h-71.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.14 189.06h-86.46l-38.08-39.72h87.1zm-83.9-6h70l-26.13-27.72h-70.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.08 162.63h-88.79a10.3 10.3 0 0 1 0-20.59h88.79a10.3 10.3 0 0 1 0 20.59zm-88.79-14.63a4.3 4.3 0 0 0 0 8.59h88.79a4.3 4.3 0 0 0 0-8.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.08 145h-88.79a7.3 7.3 0 0 0 0 14.59h88.79a7.3 7.3 0 0 0 0-14.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.8 429.15h-65.9v-69.16h6v63.16h53.9v-63.16h6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.02 429.15h-178.22v-69.16h6v63.16h172.22z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.8,
    cy: 426.15,
    r: 17.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.03,
    cy: 426.15,
    r: 17.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.8 447.14a21 21 0 1 1 21-21 21 21 0 0 1 -21 21zm0-36a15 15 0 1 0 15 15 15 15 0 0 0 -15-14.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375 447.14a21 21 0 1 1 21-21 21 21 0 0 1 -21 21zm0-36a15 15 0 1 0 15 15 15 15 0 0 0 -15-14.97z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 199.74,
    cy: 426.15,
    fill: "#f5f5f5",
    r: 6.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.03,
    cy: 426.15,
    fill: "#f5f5f5",
    r: 6.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.28 227.89a12.21 12.21 0 0 1 11.13 12.17v83.3a7 7 0 0 1 -13.89.87l-10.44-82.64a12.22 12.22 0 0 1 13.2-13.7z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.22 235.17a12.26 12.26 0 0 1 11.12 13.32l-6.88 75.45a7 7 0 0 1 -14-.3l-3.58-75.64a12.26 12.26 0 0 1 13.34-12.83z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.45 441.14h329.58v6h-329.58z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.2 175.9v-6a19.63 19.63 0 0 0 5.23-.33l1.47 5.81a23.75 23.75 0 0 1 -6.7.52zm-10 0h-6v-6h6zm26.46-7.3-4.93-3.41a10.86 10.86 0 0 0 1.78-4.32l5.91 1a16.69 16.69 0 0 1 -2.76 6.73zm-4.56-15.28a11.08 11.08 0 0 0 -3.22-3.39l3.38-5a17.06 17.06 0 0 1 5 5.25zm-11-5.28h-6v-6h6zm-16 0a33.29 33.29 0 0 1 -6.52-.3l1.07-5.91a29.09 29.09 0 0 0 5.45.21zm-16.81-5.82a19.08 19.08 0 0 1 -3.89-5.91l5.53-2.31a13 13 0 0 0 2.67 4.05zm1-16.2-5.85-1.33a18.91 18.91 0 0 1 2.83-6.49l5 3.38a13 13 0 0 0 -2.06 4.42zm8.25-9.37-2.15-5.65a19.15 19.15 0 0 1 6.92-1.17v6a13.12 13.12 0 0 0 -4.85.82zm62.85-.8v-6a24.86 24.86 0 0 0 5.37-.23l1.22 5.88a29.56 29.56 0 0 1 -6.67.35zm-10 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm58.61-6.72-4.79-3.62a10.84 10.84 0 0 0 2-4.23l5.86 1.28a16.86 16.86 0 0 1 -3.07 6.57zm-2.58-17.19c0-.1-.47-.06 6-.06z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.37 88.46a14.12 14.12 0 0 1 14.12-14.12h10.87a14.12 14.12 0 0 1 -14.13 14.12z",
    fill: "url(#linear-gradient-2)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.37 88.46a14.12 14.12 0 0 0 -14.12-14.12h-10.87a14.12 14.12 0 0 0 14.13 14.12z",
    fill: "url(#linear-gradient-3)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.23 91.46h-13.86v-3a17.14 17.14 0 0 1 17.12-17.12h13.87v3a17.14 17.14 0 0 1 -17.13 17.12zm-7.45-6h7.45a11.15 11.15 0 0 0 10.77-8.12h-7.46a11.14 11.14 0 0 0 -10.76 8.12z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.37 91.46h-13.86a17.14 17.14 0 0 1 -17.13-17.12v-3h13.87a17.14 17.14 0 0 1 17.12 17.12zm-24.58-14.12a11.15 11.15 0 0 0 10.72 8.12h7.49a11.14 11.14 0 0 0 -10.71-8.12z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382 95.52a14.13 14.13 0 0 1 0-20l7.69-7.69a14.14 14.14 0 0 1 0 20z",
    fill: "url(#linear-gradient-4)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382 95.52a14.12 14.12 0 0 0 -20 0l-7.68 7.68a14.11 14.11 0 0 0 20 0z",
    fill: "url(#linear-gradient-5)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382 99.76-2.12-2.12a17.12 17.12 0 0 1 0-24.22l9.81-9.8 2.12 2.12a17.12 17.12 0 0 1 0 24.22zm7.4-27.37-5.27 5.28a11.12 11.12 0 0 0 -1.81 13.33l5.27-5.27a11.14 11.14 0 0 0 1.83-13.34z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.25 105.32-2.12-2.12 9.8-9.8a17.12 17.12 0 0 1 24.22 0l2.12 2.12-9.81 9.8a17.09 17.09 0 0 1 -24.21 0zm6.65-2.4a11.11 11.11 0 0 0 13.32-1.84l5.27-5.27a11.13 11.13 0 0 0 -13.32 1.83z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.19 189.06-.13-6a12.64 12.64 0 0 0 4.71-1l2.37 5.51a18.61 18.61 0 0 1 -6.95 1.49zm-93.75-3h-6v-6h6zm82.56-.43a18.73 18.73 0 0 1 -4.91-5.13l5-3.25a12.9 12.9 0 0 0 3.34 3.49zm26.91-5.84-5.18-3a12.55 12.55 0 0 0 1.58-4.54l5.94.85a18.4 18.4 0 0 1 -2.34 6.69zm-109.47-9.73h-6a23.28 23.28 0 0 1 .59-6.7l5.81 1.49a18.52 18.52 0 0 0 -.4 5.21zm80.68-.71h-6a15 15 0 0 0 -.54-5l5.74-1.75a20.6 20.6 0 0 1 .8 6.75zm31.32-6.69h-6v-6h6zm-107.31-4.5-3.78-4.66a18.61 18.61 0 0 1 6.27-3.34l1.76 5.73a12.66 12.66 0 0 0 -4.25 2.27zm64.85-.35a12.42 12.42 0 0 0 -4.34-2.07l1.5-5.81a18.16 18.16 0 0 1 6.41 3.06zm-13.55-2.47h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm88-8.68h-6v-6h6zm0-16h-6v-6h6zm-6.6-15a12.53 12.53 0 0 0 -2.31-4.22l4.61-3.84a18.58 18.58 0 0 1 3.42 6.24zm-9-8.44a19.64 19.64 0 0 0 -5.26-.36v-6a24.52 24.52 0 0 1 6.68.53zm-15.26-.36h-6v-6h6z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.79 354.14a9.13 9.13 0 1 1 6.41-15.63 9.12 9.12 0 0 1 -6.41 15.63zm0-12.26a3.13 3.13 0 1 0 3.13 3.11 3.13 3.13 0 0 0 -3.13-3.11z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.05 401.56a12.46 12.46 0 1 1 12.46-12.56 12.47 12.47 0 0 1 -12.46 12.56zm0-18.91a6.46 6.46 0 1 0 6.46 6.41 6.47 6.47 0 0 0 -6.46-6.41z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.32,
    cy: 333.49,
    fill: "#f5f5f5",
    r: 58.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.32 395.18a61.69 61.69 0 1 1 61.68-61.69 61.75 61.75 0 0 1 -61.68 61.69zm0-117.37a55.69 55.69 0 1 0 55.68 55.68 55.75 55.75 0 0 0 -55.68-55.68z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.1 322.02h66v22.35h-66z",
    fill: "#e1830e",
    transform: "matrix(.707 -.707 .707 .707 -113.44 392.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.93 300.2h22.35v66h-22.35z",
    fill: "#e1830e",
    transform: "matrix(.707 -.707 .707 .707 -113.44 392.53)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.3bbf0ea1dd163bfd7be2c64e52b90639.svg";
export { ForwardRef as ReactComponent };